import { render, staticRenderFns } from "./FieldDocumentSubType.vue?vue&type=template&id=fd60f9ba&"
import script from "./FieldDocumentSubType.vue?vue&type=script&lang=js&"
export * from "./FieldDocumentSubType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports